module.exports = __webpack_public_path__ + "static/img/news_01.46415fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutus/news_01.jpg
// module id = Q6CD
// module chunks = 6